/* eslint-disable vue/multi-word-component-names */
<template>
  <div class="app-container" :class="{ 'overlay-layout': isScreenRecorderOverlayLayout }">
    <router-view v-if="isScreenRecorderOverlayLayout" />
    <template v-else>
    <!-- 手机端顶部菜单 -->
    <div class="mobile-header" v-if="isMobile && !hideMainMenu">
      <div class="mobile-header-content">
        <div class="mobile-logo">
          <el-icon class="logo-icon"><Headset /></el-icon>
          <span class="logo-text">声聚互联</span>
        </div>
        <div class="mobile-menu-toggle" @click="mobileMenuVisible = !mobileMenuVisible">
          <el-icon><Menu /></el-icon>
          <span class="menu-toggle-text">菜单</span>
        </div>
      </div>
      <el-drawer
        v-model="mobileMenuVisible"
        direction="ltr"
        :size="isMobile ? '70%' : '300px'"
        class="mobile-menu-drawer"
        :show-close="false"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :modal="true"
        :modal-append-to-body="true"
        :append-to-body="true"
      >
        <div class="mobile-menu-content">
          <div class="mobile-menu-header">
            <div class="mobile-menu-logo">
              <el-icon class="logo-icon"><Headset /></el-icon>
              <span class="logo-text">声聚互联</span>
            </div>
            <el-icon class="close-icon" @click="mobileMenuVisible = false"><Close /></el-icon>
          </div>
          <el-menu
            :default-active="activeMenu"
            class="mobile-menu"
            background-color="var(--color-bg-raised)"
            text-color="var(--color-text-primary)"
            active-text-color="var(--color-primary-light)"
            router
            @select="handleMenuSelect"
          >
            <el-menu-item index="/dashboard" v-if="isAdmin || hasPagePermission('page:dashboard')" @click="handleMenuSelect('/dashboard')">
              <el-icon><HomeFilled /></el-icon>
              <span>首页</span>
            </el-menu-item>
            <el-sub-menu index="ai-dubbing">
              <template #title>
                <el-icon><VideoCameraFilled /></el-icon>
                <span>AI配音</span>
              </template>
              <el-menu-item index="/audio/voice-generation" @click="handleMenuSelect('/audio/voice-generation')">
                <span>声音生成</span>
              </el-menu-item>
              <el-menu-item index="/ai-video-dub" @click="handleMenuSelect('/ai-video-dub')">
                <span>AI配音</span>
              </el-menu-item>
              <el-menu-item index="/voice-clone" @click="handleMenuSelect('/voice-clone')">
                <span>高级声音生成</span>
              </el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="audio-management" v-if="isAdmin || hasPagePermission('page:audio')">
              <template #title>
                <el-icon><Headset /></el-icon>
                <span>音频管理</span>
              </template>
              <el-menu-item index="/audio/list" @click="handleMenuSelect('/audio/list')">
                <span>音频管理</span>
              </el-menu-item>
              <el-menu-item v-if="canAccessVoiceGeneration" index="/audio/ai-voice-library" @click="handleMenuSelect('/audio/ai-voice-library')">
                <span>AI音库</span>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item v-if="isAdmin || hasPagePermission('page:team')" index="/progress" @click="handleMenuSelect('/progress')">
              <el-icon><DataAnalysis /></el-icon>
              <span>作品进度管理</span>
            </el-menu-item>
            <el-sub-menu index="voice-showcase">
              <template #title>
                <el-icon><Avatar /></el-icon>
                <span>声展</span>
              </template>
              <el-menu-item index="/voice/showcase" @click="handleMenuSelect('/voice/showcase')">
                <span>个人声展</span>
              </el-menu-item>
              <el-menu-item v-if="isAdmin" index="/voice/showcase-registry" @click="handleMenuSelect('/voice/showcase-registry')">
                <span>声展清单</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 画本管理（一级菜单，折叠） -->
            <el-sub-menu index="script-management">
              <template #title>
                <el-icon><Reading /></el-icon>
                <span>画本管理</span>
              </template>
              <el-menu-item index="/script/chapters" @click="handleMenuSelect('/script/chapters')">
                <span>章节管理</span>
              </el-menu-item>
              <el-menu-item v-if="canAccessScriptOnline" index="/script/online" @click="handleMenuSelect('/script/online')">
                <span>在线画本</span>
              </el-menu-item>
              <el-menu-item index="/script/my-works" @click="handleMenuSelect('/script/my-works')">
                <span>我参与的作品</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 音视频处理（仅 Electron 环境，且 isvip 为 1 时可以使用） -->
            <el-sub-menu index="media-processing" v-if="isElectron() && canAccessMediaProcessing">
              <template #title>
                <el-icon><VideoCamera /></el-icon>
                <span>音视频处理</span>
              </template>
              <el-menu-item index="/media/screen-recorder" @click="handleMenuSelect('/media/screen-recorder')">
                <el-icon><VideoCameraFilled /></el-icon>
                <span>录屏工具</span>
              </el-menu-item>
              <el-menu-item index="/media/video-compress" @click="handleMenuSelect('/media/video-compress')">
                <span>视频压缩</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-replace" @click="handleMenuSelect('/media/audio-replace')">
                <span>音频替换</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-archive" @click="handleMenuSelect('/media/audio-archive')">
                <span>音频归档</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-duration-estimate" @click="handleMenuSelect('/media/audio-duration-estimate')">
                <span>有效时长估算</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-loudness-normalize" @click="handleMenuSelect('/media/audio-loudness-normalize')">
                <span>批量音量均衡</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 结算管理（一级菜单，折叠） -->
            <el-sub-menu index="settlement-management" v-if="isAdmin || hasPagePermission('page:settlements') || hasPagePermission('page:audits') || hasPagePermission('page:payments')">
              <template #title>
                <el-icon><Money /></el-icon>
                <span>结算管理</span>
              </template>
              <el-menu-item index="/settlements" v-if="isAdmin || hasPagePermission('page:settlements')" @click="handleMenuSelect('/settlements')">
                <span>结算申请</span>
              </el-menu-item>
              <el-menu-item index="/audits" v-if="isAdmin || hasPagePermission('page:audits')" @click="handleMenuSelect('/audits')">
                <span>结算审核</span>
              </el-menu-item>
              <el-menu-item index="/payments" v-if="isAdmin || hasPagePermission('page:payments')" @click="handleMenuSelect('/payments')">
                <span>结算支付</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 合同协议管理（一级菜单，折叠） -->
            <!-- 在线录音：有声全员可见；视频剧仅管理员（手机端抽屉内隐藏） -->
            <el-sub-menu index="online-recording" class="hide-on-mobile">
              <template #title>
                <el-icon><Microphone /></el-icon>
                <span>在线录音</span>
              </template>
              <el-menu-item v-if="canAccessVideoDramaRecording" index="/video/recording/drama" @click="handleMenuSelect('/video/recording/drama')">
                <span>视频剧录音</span>
              </el-menu-item>
              <el-menu-item index="/video/recording/audiobook" @click="handleMenuSelect('/video/recording/audiobook')">
                <span>有声录音</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 视频管理（一级菜单，折叠） -->
            <el-sub-menu index="video-management" v-if="isAdmin || hasPagePermission('page:team')">
              <template #title>
                <el-icon><VideoPlay /></el-icon>
                <span>视频管理</span>
              </template>
              <el-menu-item index="/video/manage" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/video/manage')">
                <span>视频管理</span>
              </el-menu-item>
              <el-menu-item index="/video/storyboard" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/video/storyboard')">
                <span>在线分镜</span>
              </el-menu-item>
              <el-menu-item index="/video/review" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/video/review')">
                <span>在线审片</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 组织管理（一级菜单，折叠） -->
            <el-sub-menu index="team-management" v-if="isAdmin || hasPagePermission('page:team')">
              <template #title>
                <el-icon><UserFilled /></el-icon>
                <span>组织管理</span>
              </template>
              <el-menu-item index="/team" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/team')">
                <span>制作组管理</span>
              </el-menu-item>
              <el-menu-item index="/team/storage" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/team/storage')">
                <span>存储空间管理</span>
              </el-menu-item>
              <el-menu-item index="/team/efficiency" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/team/efficiency')">
                <span>人员效率评价查询</span>
              </el-menu-item>
              <el-menu-item index="/price" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/price')">
                <span>制作组价格管理</span>
              </el-menu-item>
              <el-menu-item index="/company" v-if="isAdmin || hasPagePermission('page:team')" @click="handleMenuSelect('/company')">
                <span>公司&工作室管理</span>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item index="/roles" v-if="isAdmin || hasPagePermission('page:roles')" @click="handleMenuSelect('/roles')">
              <el-icon><Lock /></el-icon>
              <span>角色管理</span>
            </el-menu-item>
            <el-menu-item index="/account" v-if="isAdmin || hasPagePermission('page:account')" @click="handleMenuSelect('/account')">
              <el-icon><User /></el-icon>
              <span>账号管理</span>
            </el-menu-item>
            <el-menu-item index="/release" v-if="isAdmin" @click="handleMenuSelect('/release')">
              <el-icon><UploadFilled /></el-icon>
              <span>软件发布</span>
            </el-menu-item>
            <!-- 手机端退出登录 -->
            <el-menu-item index="/logout" @click="handleLogout">
              <el-icon><Switch /></el-icon>
              <span>退出登录</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-drawer>
    </div>

    <el-container class="layout-container" v-if="!isMobile">
      <!-- 顶部导航栏 -->
      <el-header v-if="!hideMainMenu" height="64px" class="top-header">
        <div class="header-left">
          <div class="logo-container">
            <h1 class="logo-text">
              <el-icon class="logo-icon"><Headset /></el-icon>
              声聚互联
            </h1>
          </div>
          <!-- 桌面端菜单折叠按钮 -->
          <div class="desktop-menu-toggle" v-if="isTablet" @click="desktopMenuVisible = !desktopMenuVisible">
            <el-icon><Menu /></el-icon>
            <span class="menu-toggle-text">菜单</span>
          </div>
          <el-menu
            v-if="!isTablet"
            :default-active="activeMenu"
            class="top-menu"
            mode="horizontal"
            background-color="transparent"
            text-color="var(--color-text-regular)"
            active-text-color="var(--color-primary-light)"
            router
          >
            <el-menu-item index="/dashboard" @click="handleMenuClick('/dashboard')" v-if="isAdmin || hasPagePermission('page:dashboard')">
              <el-icon><HomeFilled /></el-icon>
              <span>首页</span>
            </el-menu-item>
            <el-sub-menu index="ai-dubbing">
              <template #title>
                <el-icon><VideoCameraFilled /></el-icon>
                <span>AI配音</span>
              </template>
              <el-menu-item index="/audio/voice-generation" @click="handleMenuClick('/audio/voice-generation')">
                <span>声音生成</span>
              </el-menu-item>
              <el-menu-item index="/ai-video-dub" @click="handleMenuClick('/ai-video-dub')">
                <span>AI配音</span>
              </el-menu-item>
              <el-menu-item index="/voice-clone" @click="handleMenuClick('/voice-clone')">
                <span>高级声音生成</span>
              </el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="audio-management" v-if="isAdmin || hasPagePermission('page:audio')">
              <template #title>
                <el-icon><Headset /></el-icon>
                <span>音频管理</span>
              </template>
              <el-menu-item index="/audio/list" @click="handleMenuClick('/audio/list')">
                <span>音频管理</span>
              </el-menu-item>
              <el-menu-item v-if="canAccessVoiceGeneration" index="/audio/ai-voice-library" @click="handleMenuClick('/audio/ai-voice-library')">
                <span>AI音库</span>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item v-if="isAdmin || hasPagePermission('page:team')" index="/progress" @click="handleMenuClick('/progress')">
              <el-icon><DataAnalysis /></el-icon>
              <span>作品进度管理</span>
            </el-menu-item>
            <el-sub-menu index="voice-showcase">
              <template #title>
                <el-icon><Avatar /></el-icon>
                <span>声展</span>
              </template>
              <el-menu-item index="/voice/showcase" @click="handleMenuClick('/voice/showcase')">
                <span>个人声展</span>
              </el-menu-item>
              <el-menu-item v-if="isAdmin" index="/voice/showcase-registry" @click="handleMenuClick('/voice/showcase-registry')">
                <span>声展清单</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 画本管理（一级菜单，向下展开） -->
            <el-sub-menu index="script-management">
              <template #title>
                <el-icon><Reading /></el-icon>
                <span>画本管理</span>
              </template>
              <el-menu-item index="/script/chapters" @click="handleMenuClick('/script/chapters')">
                <span>章节管理</span>
              </el-menu-item>
              <el-menu-item v-if="canAccessScriptOnline" index="/script/online" @click="handleMenuClick('/script/online')">
                <span>在线画本</span>
              </el-menu-item>
              <el-menu-item index="/script/my-works" @click="handleMenuClick('/script/my-works')">
                <span>我参与的作品</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 音视频处理（仅 Electron 环境，且 isvip 为 1 时可以使用） -->
            <el-sub-menu index="media-processing" v-if="isElectron() && canAccessMediaProcessing">
              <template #title>
                <el-icon><VideoCamera /></el-icon>
                <span>音视频处理</span>
              </template>
              <el-menu-item index="/media/screen-recorder" @click="handleMenuClick('/media/screen-recorder')">
                <el-icon><VideoCameraFilled /></el-icon>
                <span>录屏工具</span>
              </el-menu-item>
              <el-menu-item index="/media/video-compress" @click="handleMenuClick('/media/video-compress')">
                <span>视频压缩</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-replace" @click="handleMenuClick('/media/audio-replace')">
                <span>音频替换</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-archive" @click="handleMenuClick('/media/audio-archive')">
                <span>音频归档</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-duration-estimate" @click="handleMenuClick('/media/audio-duration-estimate')">
                <span>有效时长估算</span>
              </el-menu-item>
              <el-menu-item index="/media/audio-loudness-normalize" @click="handleMenuClick('/media/audio-loudness-normalize')">
                <span>批量音量均衡</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 结算管理（一级菜单，向下展开） -->
            <el-sub-menu index="settlement-management" v-if="isAdmin || hasPagePermission('page:settlements') || hasPagePermission('page:audits') || hasPagePermission('page:payments')">
              <template #title>
                <el-icon><Money /></el-icon>
                <span>结算管理</span>
              </template>
              <el-menu-item index="/settlements" @click="handleMenuClick('/settlements')" v-if="isAdmin || hasPagePermission('page:settlements')">
                <span>结算申请</span>
              </el-menu-item>
              <el-menu-item index="/audits" @click="handleMenuClick('/audits')" v-if="isAdmin || hasPagePermission('page:audits')">
                <span>结算审核</span>
              </el-menu-item>
              <el-menu-item index="/payments" @click="handleMenuClick('/payments')" v-if="isAdmin || hasPagePermission('page:payments')">
                <span>结算支付</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 合同协议管理（一级菜单，向下展开） -->
            <!-- 在线录音：有声全员；视频剧仅管理员 -->
            <el-sub-menu index="online-recording" class="desktop-only-menu-item">
              <template #title>
                <el-icon><Microphone /></el-icon>
                <span>在线录音</span>
              </template>
              <el-menu-item v-if="canAccessVideoDramaRecording" index="/video/recording/drama" @click="handleMenuClick('/video/recording/drama')">
                <span>视频剧录音</span>
              </el-menu-item>
              <el-menu-item index="/video/recording/audiobook" @click="handleMenuClick('/video/recording/audiobook')">
                <span>有声录音</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 视频管理（一级菜单，向下展开） -->
            <el-sub-menu index="video-management" v-if="isAdmin || hasPagePermission('page:team')">
              <template #title>
                <el-icon><VideoPlay /></el-icon>
                <span>视频管理</span>
              </template>
              <el-menu-item index="/video/manage" @click="handleMenuClick('/video/manage')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>视频管理</span>
              </el-menu-item>
              <el-menu-item index="/video/storyboard" @click="handleMenuClick('/video/storyboard')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>在线分镜</span>
              </el-menu-item>
              <el-menu-item index="/video/review" @click="handleMenuClick('/video/review')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>在线审片</span>
              </el-menu-item>
            </el-sub-menu>
            <!-- 组织管理（一级菜单，向下展开） -->
            <el-sub-menu index="team-management" v-if="isAdmin || hasPagePermission('page:team')">
              <template #title>
                <el-icon><UserFilled /></el-icon>
                <span>组织管理</span>
              </template>
              <el-menu-item index="/team" @click="handleMenuClick('/team')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>制作组管理</span>
              </el-menu-item>
              <el-menu-item index="/team/storage" @click="handleMenuClick('/team/storage')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>存储空间管理</span>
              </el-menu-item>
              <el-menu-item index="/team/efficiency" @click="handleMenuClick('/team/efficiency')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>人员效率评价查询</span>
              </el-menu-item>
              <el-menu-item index="/price" @click="handleMenuClick('/price')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>制作组价格管理</span>
              </el-menu-item>
              <el-menu-item index="/company" @click="handleMenuClick('/company')" v-if="isAdmin || hasPagePermission('page:team')">
                <span>公司&工作室管理</span>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item index="/roles" @click="handleMenuClick('/roles')" v-if="isAdmin || hasPagePermission('page:roles')">
              <el-icon><Lock /></el-icon>
              <span>角色管理</span>
            </el-menu-item>
            <el-menu-item index="/account" @click="handleMenuClick('/account')" v-if="isAdmin || hasPagePermission('page:account')">
              <el-icon><User /></el-icon>
              <span>账号管理</span>
            </el-menu-item>
            <el-menu-item index="/release" @click="handleMenuClick('/release')" v-if="isAdmin">
              <el-icon><UploadFilled /></el-icon>
              <span>软件发布</span>
            </el-menu-item>
          </el-menu>
          <!-- 桌面端折叠菜单抽屉（平板模式） -->
          <el-drawer
            v-if="isTablet"
            v-model="desktopMenuVisible"
            direction="ttb"
            :size="'auto'"
            class="desktop-menu-drawer"
            :show-close="false"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :modal="true"
          >
            <el-menu
              :default-active="activeMenu"
              class="desktop-collapsed-menu"
              mode="vertical"
              background-color="var(--color-bg-raised)"
              text-color="var(--color-text-regular)"
              active-text-color="var(--color-primary-light)"
              router
              @select="handleMenuClick"
            >
              <el-menu-item index="/dashboard" @click="handleMenuClick('/dashboard')" v-if="isAdmin || hasPagePermission('page:dashboard')">
                <el-icon><HomeFilled /></el-icon>
                <span>首页</span>
              </el-menu-item>
              <el-sub-menu index="ai-dubbing">
                <template #title>
                  <el-icon><VideoCameraFilled /></el-icon>
                  <span>AI配音</span>
                </template>
                <el-menu-item index="/audio/voice-generation" @click="handleMenuClick('/audio/voice-generation')">
                  <span>声音生成</span>
                </el-menu-item>
                <el-menu-item index="/ai-video-dub" @click="handleMenuClick('/ai-video-dub')">
                  <span>AI配音</span>
                </el-menu-item>
                <el-menu-item index="/voice-clone" @click="handleMenuClick('/voice-clone')">
                  <span>高级声音生成</span>
                </el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="audio-management" v-if="isAdmin || hasPagePermission('page:audio')">
                <template #title>
                  <el-icon><Headset /></el-icon>
                  <span>音频管理</span>
                </template>
                <el-menu-item index="/audio/list" @click="handleMenuClick('/audio/list')">
                  <span>音频管理</span>
                </el-menu-item>
                <el-menu-item v-if="canAccessVoiceGeneration" index="/audio/ai-voice-library" @click="handleMenuClick('/audio/ai-voice-library')">
                  <span>AI音库</span>
                </el-menu-item>
              </el-sub-menu>
              <el-menu-item v-if="isAdmin || hasPagePermission('page:team')" index="/progress" @click="handleMenuClick('/progress')">
                <el-icon><DataAnalysis /></el-icon>
                <span>作品进度管理</span>
              </el-menu-item>
              <el-sub-menu index="voice-showcase-mobile">
                <template #title>
                  <el-icon><Avatar /></el-icon>
                  <span>声展</span>
                </template>
                <el-menu-item index="/voice/showcase" @click="handleMenuClick('/voice/showcase')">
                  <span>个人声展</span>
                </el-menu-item>
                <el-menu-item v-if="isAdmin" index="/voice/showcase-registry" @click="handleMenuClick('/voice/showcase-registry')">
                  <span>声展清单</span>
                </el-menu-item>
              </el-sub-menu>
              <!-- 画本管理（一级菜单，向下展开） -->
              <el-sub-menu index="script-management">
                <template #title>
                  <el-icon><Reading /></el-icon>
                  <span>画本管理</span>
                </template>
                <el-menu-item index="/script/chapters" @click="handleMenuClick('/script/chapters')">
                  <span>章节管理</span>
                </el-menu-item>
                <el-menu-item v-if="canAccessScriptOnline" index="/script/online" @click="handleMenuClick('/script/online')">
                  <span>在线画本</span>
                </el-menu-item>
                <el-menu-item index="/script/my-works" @click="handleMenuClick('/script/my-works')">
                  <span>我参与的作品</span>
                </el-menu-item>
              </el-sub-menu>
              <!-- 音视频处理（仅 Electron 环境，且 isvip 为 1 时可以使用） -->
            <el-sub-menu index="media-processing" v-if="isElectron() && canAccessMediaProcessing">
              <template #title>
                <el-icon><VideoCamera /></el-icon>
                <span>音视频处理</span>
              </template>
              <el-menu-item index="/media/screen-recorder" @click="handleMenuClick('/media/screen-recorder')">
                <el-icon><VideoCameraFilled /></el-icon>
                <span>录屏工具</span>
              </el-menu-item>
              <el-menu-item index="/media/video-compress" @click="handleMenuClick('/media/video-compress')">
                <span>视频压缩</span>
              </el-menu-item>
                <el-menu-item index="/media/audio-replace" @click="handleMenuClick('/media/audio-replace')">
                  <span>音频替换</span>
                </el-menu-item>
                <el-menu-item index="/media/audio-archive" @click="handleMenuClick('/media/audio-archive')">
                  <span>音频归档</span>
                </el-menu-item>
                <el-menu-item index="/media/audio-duration-estimate" @click="handleMenuClick('/media/audio-duration-estimate')">
                  <span>有效时长估算</span>
                </el-menu-item>
                <el-menu-item index="/media/audio-loudness-normalize" @click="handleMenuClick('/media/audio-loudness-normalize')">
                  <span>批量音量均衡</span>
                </el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="settlement-management" v-if="isAdmin || hasPagePermission('page:settlements') || hasPagePermission('page:audits') || hasPagePermission('page:payments')">
                <template #title>
                  <el-icon><Money /></el-icon>
                  <span>结算管理</span>
                </template>
                <el-menu-item index="/settlements" @click="handleMenuClick('/settlements')" v-if="isAdmin || hasPagePermission('page:settlements')">
                  <span>结算申请</span>
                </el-menu-item>
                <el-menu-item index="/audits" @click="handleMenuClick('/audits')" v-if="isAdmin || hasPagePermission('page:audits')">
                  <span>结算审核</span>
                </el-menu-item>
                <el-menu-item index="/payments" @click="handleMenuClick('/payments')" v-if="isAdmin || hasPagePermission('page:payments')">
                  <span>结算支付</span>
                </el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="online-recording-tablet">
                <template #title>
                  <el-icon><Microphone /></el-icon>
                  <span>在线录音</span>
                </template>
                <el-menu-item v-if="canAccessVideoDramaRecording" index="/video/recording/drama" @click="handleMenuClick('/video/recording/drama')">
                  <span>视频剧录音</span>
                </el-menu-item>
                <el-menu-item index="/video/recording/audiobook" @click="handleMenuClick('/video/recording/audiobook')">
                  <span>有声录音</span>
                </el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="video-management" v-if="isAdmin || hasPagePermission('page:team')">
                <template #title>
                  <el-icon><VideoPlay /></el-icon>
                  <span>视频管理</span>
                </template>
                <el-menu-item index="/video/manage" @click="handleMenuClick('/video/manage')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>视频管理</span>
                </el-menu-item>
                <el-menu-item index="/video/storyboard" @click="handleMenuClick('/video/storyboard')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>在线分镜</span>
                </el-menu-item>
                <el-menu-item index="/video/review" @click="handleMenuClick('/video/review')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>在线审片</span>
                </el-menu-item>
              </el-sub-menu>
              <el-sub-menu index="team-management" v-if="isAdmin || hasPagePermission('page:team')">
                <template #title>
                  <el-icon><UserFilled /></el-icon>
                  <span>组织管理</span>
                </template>
                <el-menu-item index="/team" @click="handleMenuClick('/team')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>制作组管理</span>
                </el-menu-item>
                <el-menu-item index="/team/storage" @click="handleMenuClick('/team/storage')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>存储空间管理</span>
                </el-menu-item>
                <el-menu-item index="/price" @click="handleMenuClick('/price')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>制作组价格管理</span>
                </el-menu-item>
                <el-menu-item index="/company" @click="handleMenuClick('/company')" v-if="isAdmin || hasPagePermission('page:team')">
                  <span>公司&工作室管理</span>
                </el-menu-item>
              </el-sub-menu>
              <el-menu-item index="/roles" @click="handleMenuClick('/roles')" v-if="isAdmin || hasPagePermission('page:roles')">
                <el-icon><Lock /></el-icon>
                <span>角色管理</span>
              </el-menu-item>
              <el-menu-item index="/account" @click="handleMenuClick('/account')" v-if="isAdmin || hasPagePermission('page:account')">
                <el-icon><User /></el-icon>
                <span>账号管理</span>
              </el-menu-item>
              <el-menu-item index="/release" @click="handleMenuClick('/release')" v-if="isAdmin">
                <el-icon><UploadFilled /></el-icon>
                <span>软件发布</span>
              </el-menu-item>
            </el-menu>
          </el-drawer>
        </div>
        <div class="header-right">
          <el-breadcrumb separator="/" class="breadcrumb-nav">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ currentRoute.meta.title }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button class="btn-homepage" size="small" @click="goHomepage">官网首页</el-button><div class="header-balance-wrap">
            <span class="header-balance" @click="goRecharge">
                <span class="star-balance-inner">
                  <svg class="coin-svg" viewBox="0 0 24 24" width="16" height="16"><defs><linearGradient id="cg2" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#ffe066"/><stop offset="100%" stop-color="#d4a017"/></linearGradient></defs><circle cx="12" cy="12" r="11" fill="url(#cg2)" stroke="#8b6914" stroke-width="2"/><text x="12" y="17" text-anchor="middle" font-size="14" font-weight="bold" fill="#8b6914">¥</text></svg>
                  <b>{{ balanceYuan }}</b> 星点
                </span>
            </span>
            <el-button size="small" type="warning" plain @click="goRecharge">充值</el-button>
          </div>
          <ThemeSwitcher class="header-theme-switcher" />
          <el-dropdown>
            <span class="user-info">
              <el-avatar :size="28" :src="avatarUrl" :icon="UserFilled"></el-avatar>
              {{ username }}
              <el-icon><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu class="user-menu">
                <!-- 存储空间（从顶部菜单移入） -->
                <div class="user-menu-storage" @click="goToTeamStorage" role="button">
                  <div class="user-menu-storage-head">
                    <span class="user-menu-storage-label">
                      <el-icon><DataAnalysis /></el-icon>
                      存储空间
                    </span>
                    <span class="user-menu-storage-meta">{{ storageText }}</span>
                  </div>
                  <div class="user-menu-storage-bar">
                    <div
                      class="user-menu-storage-fill"
                      :style="{ width: storagePercent + '%', background: storageColor }"
                    ></div>
                  </div>
                  <div class="user-menu-storage-foot">
                    <span class="user-menu-storage-percent" :style="{ color: storageColor }">已用 {{ Math.round(storagePercent) }}%</span>
                    <span class="user-menu-storage-cost" v-if="dailyStorageCost">-{{ dailyStorageCost }} 星点/天</span>
                  </div>
                </div>
                <el-divider class="user-menu-divider" />
                <el-dropdown-item @click="openUserInfoDialog">个人信息</el-dropdown-item>
                <el-dropdown-item v-if="isAdmin" @click="openConfigDialog">系统虚拟币比例设置</el-dropdown-item>
                <el-dropdown-item v-if="isAdmin" @click="openArchiveDialog">OSS文件归档</el-dropdown-item>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容区域 -->
      <el-main :class="['main-container', { fullscreen: hideMainMenu }]">
        <router-view />
      </el-main>
    </el-container>

    <!-- 手机端内容区域 -->
    <div :class="['mobile-main-container', { fullscreen: hideMainMenu }]" v-if="isMobile">
      <router-view />
    </div>
    </template>
  </div>

  <!-- 个人信息对话框 -->
  <el-dialog
    v-model="userInfoDialogVisible"
    title="个人信息"
    width="600px"
  >
    <!-- 使用QQ登录且需要补全信息时的提示 -->
    <div
      v-if="userInfo.qq"
      style="margin: 0 0 12px 0;"
    >
      <el-alert
        type="info"
        show-icon
        :closable="false"
        title="如果已经通过非QQ登录注册过，填写相同的姓名、身份证号等信息后，将合并为同一账号。"
      />
    </div>
    <el-form :model="userInfo" label-width="120px" :rules="rules" ref="userInfoFormRef">
      <el-form-item label="头像">
        <div class="avatar-uploader-container">
          <el-avatar :size="80" :src="avatarUrl" :icon="UserFilled" />
          <el-upload
            class="avatar-uploader"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleAvatarChange"
          >
            <el-button type="primary" size="small">更换头像</el-button>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="userInfo.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-input v-model="userInfo.role" disabled placeholder="用户角色" />
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input v-model="userInfo.idCard" placeholder="请输入身份证号" maxlength="18" />
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="userInfo.phone" placeholder="请输入手机号码" maxlength="11" />
        <div class="form-hint">显示格式：{{ formatPhone(userInfo.phone) }}</div>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="userInfo.nickname" placeholder="请输入昵称" />
      </el-form-item>
      <el-form-item label="QQ号码" prop="qq">
        <el-input v-model="userInfo.qq" placeholder="请输入QQ号码" disabled />
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankCard">
        <el-input v-model="userInfo.bankCard" placeholder="请输入银行卡号" />
        <div class="form-hint">显示格式：{{ formatBankCard(userInfo.bankCard) }}</div>
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <el-input v-model="userInfo.bankName" placeholder="请输入开户行" />
      </el-form-item>
      <el-form-item label="收件地址" prop="address">
        <el-input v-model="userInfo.address" placeholder="请输入收件地址" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="userInfoDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUserInfo" :loading="saveLoading">保存</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- OSS 文件归档 -->
  <el-dialog
    v-model="archiveDialogVisible"
    title="OSS文件归档"
    width="960px"
    class="archive-dialog"
    :close-on-click-modal="false"
  >
    <el-alert
      title="归档会把 OSS 文件复制到归档 bucket、校验、更新数据库路径后删除源文件。正式执行前请先预览。"
      type="warning"
      show-icon
      :closable="false"
      class="archive-alert"
    />

    <el-tabs v-model="archiveForm.mode" @tab-change="resetArchivePreview">
      <el-tab-pane label="按作品归档" name="works">
        <el-tabs v-model="archiveStatusTab" class="archive-status-tabs" @tab-change="resetArchivePreview">
          <el-tab-pane label="全部" name="all" />
          <el-tab-pane label="未归档" name="未归档" />
          <el-tab-pane label="部分归档" name="部分归档" />
          <el-tab-pane label="已归档" name="已归档" />
          <el-tab-pane label="无音频" name="无音频" />
        </el-tabs>
        <div class="archive-toolbar">
          <el-input
            v-model="workSearchKeyword"
            clearable
            placeholder="搜索作品名称或ID"
            class="archive-search"
          />
          <el-date-picker
            v-model="workCreateTimeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="作品开始时间"
            end-placeholder="作品结束时间"
            value-format="YYYY-MM-DD HH:mm:ss"
            class="archive-date-range"
          />
          <el-button @click="loadArchiveWorks" :loading="worksLoading">刷新作品</el-button>
        </div>
        <el-select
          v-model="archiveForm.workIds"
          multiple
          filterable
          clearable
          collapse-tags
          collapse-tags-tooltip
          placeholder="请选择要整部归档的作品"
          class="archive-work-select"
          :loading="worksLoading"
        >
          <el-option
            v-for="work in filteredArchiveWorks"
            :key="work.id"
            :label="work.label"
            :value="work.id"
            :disabled="work.disabled"
          >
            <div class="archive-work-option">
              <div class="archive-work-main">
                <span>{{ work.label }}</span>
                <small>{{ work.displayTime || '-' }}</small>
              </div>
              <div class="archive-work-tags">
                <el-tag
                  size="small"
                  :type="work.archiveTagType"
                  effect="plain"
                >
                  {{ work.archiveStatusText }}
                </el-tag>
                <small v-if="work.archiveTotalAudioCount">
                  {{ work.archivedAudioCount }}/{{ work.archiveTotalAudioCount }} · {{ work.archiveProgress }}%
                </small>
              </div>
            </div>
          </el-option>
        </el-select>
      </el-tab-pane>

      <el-tab-pane label="按音频创建时间归档" name="time">
        <el-form label-width="110px" class="archive-time-form">
          <el-form-item label="筛选方式">
            <el-radio-group v-model="archiveForm.timeMode" @change="resetArchivePreview">
              <el-radio-button label="range">时间范围</el-radio-button>
              <el-radio-button label="before">截止时间</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="archiveForm.timeMode === 'range'" label="时间范围">
            <el-date-picker
              v-model="archiveForm.timeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="音频开始时间"
              end-placeholder="音频结束时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              class="archive-date-range"
            />
          </el-form-item>
          <el-form-item v-else label="截止时间">
            <el-date-picker
              v-model="archiveForm.beforeTime"
              type="datetime"
              placeholder="归档此时间之前的音频"
              value-format="YYYY-MM-DD HH:mm:ss"
              class="archive-date-range"
            />
          </el-form-item>
          <el-form-item label="预览上限">
            <el-input-number v-model="archiveForm.limit" :min="1" :max="1000" :step="50" />
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div class="archive-options">
      <span>并发数</span>
      <el-input-number v-model="archiveForm.concurrency" :min="1" :max="2" />
      <span class="archive-muted">建议 1-2，作品模式不受时间条件影响。</span>
    </div>

    <el-divider />

    <section v-if="archivePreview" class="archive-section">
      <div class="archive-section-head">
        <strong>预览结果</strong>
        <span class="archive-muted">将归档 {{ archivePreviewSelected }} 条文件</span>
      </div>
      <el-table :data="archivePreviewRows" height="220" size="small" border>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="sourcePath" label="原路径" min-width="260" show-overflow-tooltip />
        <el-table-column prop="targetPath" label="目标路径" min-width="260" show-overflow-tooltip />
      </el-table>
    </section>

    <section v-if="archiveJob" class="archive-section">
      <div class="archive-section-head">
        <strong>任务进度</strong>
        <span class="archive-muted">Job ID: {{ archiveJob.jobId }}</span>
      </div>
      <el-progress :percentage="archiveJobPercent" :status="archiveJobStatus" :stroke-width="12" />
      <div class="archive-stats">
        <span>状态：{{ archiveJob.status || '-' }}</span>
        <span>总数：{{ archiveJob.total || archiveJob.selected || 0 }}</span>
        <span>已处理：{{ archiveJob.processed || 0 }}</span>
        <span>成功：{{ archiveJob.success || 0 }}</span>
        <span>失败：{{ archiveJob.failed || 0 }}</span>
        <span>删除失败：{{ archiveJob.deleteFailed || 0 }}</span>
      </div>
      <el-table :data="archiveJobResults" height="180" size="small" border>
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column prop="sourcePath" label="原路径" min-width="220" show-overflow-tooltip />
        <el-table-column prop="targetPath" label="目标路径" min-width="220" show-overflow-tooltip />
        <el-table-column prop="message" label="说明" min-width="160" show-overflow-tooltip />
      </el-table>
    </section>

    <template #footer>
      <el-button @click="archiveDialogVisible = false">关闭</el-button>
      <el-button @click="previewArchive" :loading="archivePreviewLoading">预览</el-button>
      <el-button
        type="primary"
        @click="startArchive"
        :loading="archiveSubmitLoading"
        :disabled="!archivePreview || archivePreviewSelected <= 0"
      >
        确认归档
      </el-button>
    </template>
  </el-dialog>

  <!-- 系统虚拟币比例配置 -->
  <el-dialog
    v-model="configDialogVisible"
    title="系统虚拟币比例配置"
    width="520px"
    :close-on-click-modal="false"
  >
    <div style="padding:0 0 8px;">
      <el-form label-width="140px">
        <el-form-item label="充值比例 (1元=兑换积分)">
          <el-input-number v-model="configPointsPerYuan" :min="1" :max="10000" :step="10" controls-position="right" style="width:180px" />
        </el-form-item>
        <el-form-item label="消费倍率 (100=原价,200=翻倍)">
          <el-input-number v-model="configConsumptionRatio" :min="1" :max="1000" :step="10" controls-position="right" style="width:180px" />
        </el-form-item>
      </el-form>
      <div class="muted" style="margin-bottom:16px;">当前：充值 {{ rechargeConfig.pointsPerYuan }} 积分/元 | 消费 {{ rechargeConfig.consumptionRatio }}%</div>
      <div style="text-align:right;padding-top:12px;border-top:1px solid rgba(255,255,255,0.1);">
        <el-button @click="configDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="configSaving" @click="saveRechargeConfig">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, onMounted, reactive, onUnmounted, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getBalance, updateRechargeConfig } from '@/api/modules/recharge'
import { rechargeConfig, fetchRechargeConfig } from '@/stores/modules/rechargeConfig'
import { 
  HomeFilled, 
  Calendar, 
  Document, 
  Check, 
  Money, 
  DataAnalysis, 
  Fold, 
  Expand, 
  ArrowDown,
  UserFilled,
  Headset,
  User,
  Lock,
  Menu,
  Close,
  UploadFilled,
  Box,
  VideoPlay,
  View,
  Microphone,
  VideoCamera,
  VideoCameraFilled,
  Switch,
  FolderOpened,
  Timer,
  Reading,
  Avatar
} from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import http, { get } from '@/api/http'
import { hasPermission, getUserPermissions } from '@/utils/permission'
import { getProfile } from '@/api/modules/auth'
import { getWorks } from '@/api/modules/audio'
import { archiveOssFiles, getArchiveOssFilesJob } from '@/api/modules/system'
import { useUserStore } from '@/store/modules/user'
import { useCompanyAccessStore } from '@/store/modules/companyAccess'
import ThemeSwitcher from '@/components/ThemeSwitcher.vue'
import { isElectron } from '@/utils/electron'
const { API_URL } = require('../../../config')

const router = useRouter()

// ??????
const balanceYuan = ref('0')
async function fetchBalance() {
  try {
    const res = await getBalance()
    const data = res?.data ?? res
    const stars = data?.points ?? 0
    balanceYuan.value = String(stars)
  } catch { /* */ }
}
onMounted(() => { fetchBalance(); fetchRechargeConfig() })
const handleRefreshBalance = () => {
  void fetchBalance()
}
window.addEventListener('refresh-balance', handleRefreshBalance)
watch(() => rechargeConfig.balanceVersion, () => { fetchBalance() })

const configDialogVisible = ref(false)
const configPointsPerYuan = ref(100)
const configConsumptionRatio = ref(100)
const configSaving = ref(false)

function openConfigDialog() {
  configPointsPerYuan.value = rechargeConfig.pointsPerYuan
  configConsumptionRatio.value = rechargeConfig.consumptionRatio
  configDialogVisible.value = true
}

async function saveRechargeConfig() {
  configSaving.value = true
  try {
    const payload = {}
    if (configPointsPerYuan.value !== rechargeConfig.pointsPerYuan) {
      payload.points_per_yuan = configPointsPerYuan.value
    }
    if (configConsumptionRatio.value !== rechargeConfig.consumptionRatio) {
      payload.consumption_ratio = configConsumptionRatio.value
    }
    if (Object.keys(payload).length === 0) {
      configDialogVisible.value = false
      return
    }
    await updateRechargeConfig(payload)
    await fetchRechargeConfig()
    ElMessage.success('配置已保存')
    configDialogVisible.value = false
  } catch (e) {
    ElMessage.error(e?.response?.data?.message || e?.message || '保存失败')
  } finally {
    configSaving.value = false
  }
}

function goRecharge() {
  router.push('/recharge')
}
const route = useRoute()
const userStore = useUserStore()
const companyAccessStore = useCompanyAccessStore()
const username = computed(() => userStore.username)
// 是否可以访问音视频处理功能（isvip 为 1 时可以使用）
const canAccessMediaProcessing = computed(() => {
  return userStore.canAccessMediaProcessing
})
const userInfoDialogVisible = ref(false)
const saveLoading = ref(false)
const userInfoFormRef = ref(null)
const mobileMenuVisible = ref(false)
const desktopMenuVisible = ref(false)
const isMobile = ref(false)
const isTablet = ref(false)
const archiveDialogVisible = ref(false)
const worksLoading = ref(false)
const archivePreviewLoading = ref(false)
const archiveSubmitLoading = ref(false)
const archiveWorks = ref([])
const archiveStatusTab = ref('all')
const workSearchKeyword = ref('')
const workCreateTimeRange = ref(null)
const archivePreview = ref(null)
const archiveJob = ref(null)
const archivePollTimer = ref(null)
const archiveForm = reactive({
  mode: 'works',
  workIds: [],
  timeMode: 'range',
  timeRange: null,
  beforeTime: '',
  concurrency: 2,
  limit: 100
})

// 用户权限
const userPermissions = ref([])

// 判断当前用户是否拥有指定权限
const hasPagePermission = (permission) => {
  return hasPermission(permission)
}

// 公司角色权限控制的功能开关（管理员默认放行）
// 在线画本 / 声音生成 / 视频剧录音：以 GET /api/companies 返回的各公司 permissions 为准（与 profile 解耦）
const canAccessScriptOnline = computed(() => isAdmin.value || companyAccessStore.hasScriptOnline)
const canAccessVoiceGeneration = computed(() => isAdmin.value || companyAccessStore.hasVoiceGeneration)
const canAccessVideoDramaRecording = computed(() => isAdmin.value || companyAccessStore.hasVideoDramaRecording)

// 判断当前用户是否为管理员
const isAdmin = computed(() => {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')
  return roles.includes('admin')
})

const filteredArchiveWorks = computed(() => {
  const keyword = workSearchKeyword.value.trim().toLowerCase()
  const range = Array.isArray(workCreateTimeRange.value) ? workCreateTimeRange.value : null
  return archiveWorks.value.filter(work => {
    const text = `${work.id} ${work.label}`.toLowerCase()
    if (keyword && !text.includes(keyword)) return false
    if (archiveStatusTab.value !== 'all' && work.archiveStatus !== archiveStatusTab.value) return false
    if (range && range[0] && range[1] && work.createTime) {
      const createTime = new Date(work.createTime).getTime()
      const startTime = new Date(range[0]).getTime()
      const endTime = new Date(range[1]).getTime()
      if (Number.isFinite(createTime) && Number.isFinite(startTime) && Number.isFinite(endTime)) {
        return createTime >= startTime && createTime <= endTime
      }
    }
    return true
  }).sort((a, b) => {
    if (a.disabled !== b.disabled) return a.disabled ? 1 : -1
    const aTime = Number.isFinite(a.createTimeMs) ? a.createTimeMs : Number.MAX_SAFE_INTEGER
    const bTime = Number.isFinite(b.createTimeMs) ? b.createTimeMs : Number.MAX_SAFE_INTEGER
    if (aTime !== bTime) return aTime - bTime
    return Number(a.id || 0) - Number(b.id || 0)
  })
})

const archivePreviewRows = computed(() => {
  return normalizeArchiveRows(archivePreview.value?.items || archivePreview.value?.results || archivePreview.value?.list || [], {
    onlyMovable: true
  })
})
const archivePreviewSelected = computed(() => {
  const data = archivePreview.value || {}
  return Number(data.selected ?? data.total ?? data.count ?? archivePreviewRows.value.length) || 0
})
const archiveJobPercent = computed(() => {
  const job = archiveJob.value || {}
  const total = Number(job.total || job.selected || 0)
  const processed = Number(job.processed || 0)
  if (!total) return 0
  return Math.min(100, Math.round((processed / total) * 100))
})
const archiveJobStatus = computed(() => {
  const status = String(archiveJob.value?.status || '').toLowerCase()
  if (status === 'failed') return 'exception'
  if (status === 'finished' || status === 'completed' || status === 'success') return 'success'
  return undefined
})
const archiveJobResults = computed(() => normalizeArchiveRows(archiveJob.value?.results || []))

watch(
  () => [
    archiveForm.mode,
    archiveForm.workIds.join(','),
    archiveForm.timeMode,
    Array.isArray(archiveForm.timeRange) ? archiveForm.timeRange.join('|') : '',
    archiveForm.beforeTime,
    archiveForm.limit,
    archiveForm.concurrency
  ],
  resetArchivePreview
)

// 个人信息表单数据
const userInfo = reactive({
  avatar: '',
  name: '',
  role: '',  // 添加角色字段
  idCard: '',
  phone: '',
  nickname: '',
  qq: '',
  bankCard: '',
  bankName: '',
  address: '',
  avatarFile: null
})

// 表单验证规则
const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  idCard: [
    { required: true, message: '请输入身份证号', trigger: 'blur' },
    { validator: validateIdCard, trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  bankCard: [
    { required: true, message: '请输入银行卡号', trigger: 'blur' },
    { pattern: /^\d{10,}$/, message: '请输入10位及以上纯数字', trigger: 'blur' }
  ],
  bankName: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
  address: [{ required: true, message: '请输入收件地址', trigger: 'blur' }]
}

// 计算当前激活的菜单
const activeMenu = computed(() => {
  return route.path
})

// 在线画本等沉浸式页面隐藏主菜单
const hideMainMenu = computed(() => {
  const p = route.path || ''
  const overlay = String(route.query?.overlay || '') === '1'
  if (overlay || screenRecorderActive.value) return true
  // 只在“画本编辑界面”隐藏主菜单；作品选择/列表等阶段不隐藏
  if (p === '/script/online') {
    const view = String(route.query?.view || '').toLowerCase()
    return view === 'editor'
  }
  return false
})

const screenRecorderActive = ref(false)
const isScreenRecorderOverlayLayout = computed(() => String(route.query?.overlay || '') === '1')

// 获取当前路由信息
const currentRoute = computed(() => {
  return route
})

// 处理菜单点击事件
const handleMenuClick = (path) => {
  console.log('菜单点击:', path)
  // 如果是平板端，点击菜单后关闭折叠菜单
  if (isTablet.value) {
    desktopMenuVisible.value = false
  }
  // 路由已经通过el-menu的router属性自动处理
  // 这里可以添加额外的处理逻辑
}

// 处理手机端菜单选择
const handleMenuSelect = (index) => {
  // 先关闭菜单
  mobileMenuVisible.value = false
  // 然后跳转路由
  nextTick(() => {
    router.push(index).catch(() => {})
  })
}

function normalizeWorksResponse(res) {
  const list = Array.isArray(res)
    ? res
    : Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res?.data?.items)
        ? res.data.items
        : Array.isArray(res?.data?.list)
          ? res.data.list
          : Array.isArray(res?.data?.works)
            ? res.data.works
            : Array.isArray(res?.works)
              ? res.works
              : []
  return list.map(work => {
    const id = work.id ?? work.workId ?? work.workid
    const name = work.workname || work.workName || work.work_name || work.name || work.title || work.teamname || work.teamName || `作品 ${id}`
    const createTime = work.createtime || work.createTime || work.createdAt || work.created_at || ''
    const createTimeMs = new Date(createTime).getTime()
    const archiveStatus = work.archiveStatus || '无音频'
    const archivedAudioCount = Number(work.archivedAudioCount || 0)
    const archiveTotalAudioCount = Number(work.archiveTotalAudioCount || 0)
    const archiveProgress = Number(work.archiveProgress || 0)
    const hasUnarchivedAudio = Boolean(work.hasUnarchivedAudio)
    const disabled = archiveStatus === '已归档' || !hasUnarchivedAudio
    return {
      id,
      label: `${name}（ID: ${id}）`,
      createTime,
      createTimeMs,
      displayTime: formatArchiveDateTime(createTime),
      archiveStatus,
      archiveStatusText: getArchiveStatusText(archiveStatus),
      archivedAudioCount,
      archiveTotalAudioCount,
      unarchivedAudioCount: Number(work.unarchivedAudioCount || 0),
      archiveProgress,
      hasUnarchivedAudio,
      disabled,
      archiveTagType: getArchiveStatusTagType(archiveStatus)
    }
  }).filter(work => work.id != null && work.id !== '')
}

function formatArchiveDateTime(value) {
  if (!value) return ''
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return String(value)
  const pad = (n) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

function getArchiveStatusTagType(status) {
  if (status === '已归档') return 'success'
  if (status === '部分归档') return 'warning'
  if (status === '未归档') return 'info'
  return 'info'
}

function getArchiveStatusText(status) {
  if (status === '无音频') return '无可归档音频'
  return status || '未知'
}

function normalizeArchiveRows(rows, options = {}) {
  if (!Array.isArray(rows)) return []
  return rows
    .filter(row => {
      if (!options.onlyMovable) return true
      if (row.skipReason === 'already_archived') return false
      const archiveStatus = String(row.archiveStatus || row.archive_status || '').trim()
      if (archiveStatus === 'already_archived' || archiveStatus === '已归档' || archiveStatus === 'archived') return false
      if (row.canMove === false) return false
      return true
    })
    .map((row, index) => ({
      id: row.id ?? row.audioId ?? row.audio_id ?? row.fileId ?? index + 1,
      status: row.status || row.state || row.archiveStatus || '',
      sourcePath: row.sourcePath || row.source || row.from || row.filepath || row.filePath || row.src || '',
      targetPath: row.targetPath || row.target || row.to || row.archivePath || row.dest || '',
      message: row.message || row.error || row.reason || row.skipReason || ''
    }))
}

function unwrapArchiveResponse(res) {
  return res?.data || res || {}
}

function resetArchivePreview() {
  archivePreview.value = null
}

function stopArchivePolling() {
  if (archivePollTimer.value) {
    clearInterval(archivePollTimer.value)
    archivePollTimer.value = null
  }
}

function buildArchivePayload(extra = {}) {
  const payload = {
    concurrency: archiveForm.concurrency,
    ...extra
  }
  if (archiveForm.mode === 'works') {
    payload.workIds = archiveForm.workIds
  } else {
    payload.limit = archiveForm.limit
    if (archiveForm.timeMode === 'range') {
      payload.startTime = archiveForm.timeRange?.[0]
      payload.endTime = archiveForm.timeRange?.[1]
    } else {
      payload.beforeTime = archiveForm.beforeTime
    }
  }
  return payload
}

function validateArchivePayload(payload) {
  if (archiveForm.mode === 'works') {
    if (!Array.isArray(payload.workIds) || payload.workIds.length === 0) {
      ElMessage.warning('请选择要归档的作品')
      return false
    }
    return true
  }
  if (archiveForm.timeMode === 'range' && (!payload.startTime || !payload.endTime)) {
    ElMessage.warning('请选择音频创建时间范围')
    return false
  }
  if (archiveForm.timeMode === 'before' && !payload.beforeTime) {
    ElMessage.warning('请选择截止时间')
    return false
  }
  return true
}

async function loadArchiveWorks() {
  worksLoading.value = true
  try {
    const res = await getWorks()
    archiveWorks.value = normalizeWorksResponse(res)
    const disabledIds = new Set(archiveWorks.value.filter(work => work.disabled).map(work => String(work.id)))
    archiveForm.workIds = archiveForm.workIds.filter(id => !disabledIds.has(String(id)))
  } catch (e) {
    archiveWorks.value = []
    ElMessage.error(e?.message || '加载作品列表失败')
  } finally {
    worksLoading.value = false
  }
}

async function openArchiveDialog() {
  if (!isAdmin.value) {
    ElMessage.error('只有超级管理员可以使用归档功能')
    return
  }
  archiveDialogVisible.value = true
  if (archiveWorks.value.length === 0) {
    await loadArchiveWorks()
  }
}

async function previewArchive() {
  const payload = buildArchivePayload({ dryRun: true })
  if (!validateArchivePayload(payload)) return
  archivePreviewLoading.value = true
  archivePreview.value = null
  try {
    const res = await archiveOssFiles(payload)
    archivePreview.value = unwrapArchiveResponse(res)
    if (archivePreviewSelected.value === 0) {
      ElMessage.warning('预览未选中可归档文件')
    } else {
      ElMessage.success(`预览完成，共 ${archivePreviewSelected.value} 条`)
    }
  } catch (e) {
    ElMessage.error(e?.response?.data?.message || e?.message || '预览失败')
  } finally {
    archivePreviewLoading.value = false
  }
}

async function pollArchiveJob(jobId) {
  if (!jobId) return
  try {
    const res = await getArchiveOssFilesJob(jobId)
    archiveJob.value = unwrapArchiveResponse(res)
    const status = String(archiveJob.value?.status || '').toLowerCase()
    if (['finished', 'completed', 'success', 'failed', 'cancelled'].includes(status)) {
      stopArchivePolling()
      await loadArchiveWorks()
    }
  } catch (e) {
    stopArchivePolling()
    ElMessage.error(e?.message || '查询归档进度失败')
  }
}

async function startArchive() {
  const payload = buildArchivePayload({ confirm: true, dryRun: false })
  if (!validateArchivePayload(payload)) return
  try {
    await ElMessageBox.confirm(
      `确认开始归档 ${archivePreviewSelected.value} 条文件？任务开始后会在后台移动 OSS 文件并更新数据库路径。`,
      '确认归档',
      { type: 'warning', confirmButtonText: '开始归档', cancelButtonText: '取消' }
    )
  } catch (e) {
    return
  }
  archiveSubmitLoading.value = true
  try {
    const res = await archiveOssFiles(payload)
    archiveJob.value = unwrapArchiveResponse(res)
    const jobId = archiveJob.value?.jobId
    ElMessage.success('归档任务已开始')
    stopArchivePolling()
    if (jobId) {
      await pollArchiveJob(jobId)
      archivePollTimer.value = setInterval(() => pollArchiveJob(jobId), 3000)
    }
  } catch (e) {
    ElMessage.error(e?.response?.data?.message || e?.message || '发起归档任务失败')
  } finally {
    archiveSubmitLoading.value = false
  }
}


// 打开个人信息对话框
const openUserInfoDialog = async () => {
  // token 校验，若无token则强制跳转登录页（用 router 保持 hash 一致，避免 /login#/login）
  if (!localStorage.getItem('token')) {
    router.replace('/login')
    return
  }
  try {
    const userData = await userStore.fetchUserInfo()
    if (userData && userData.id) {
      userInfo.name = userData.name || ''
      userInfo.role = userData.role || ''
      userInfo.idCard = userData.idCard || ''
      userInfo.phone = userData.phone || ''
      userInfo.nickname = userData.nickname || ''
      userInfo.qq = userData.qq || ''
      userInfo.bankCard = userData.bankCard || ''
      userInfo.bankName = userData.bankName || ''
      userInfo.address = userData.address || ''
      userInfo.avatar = userData.avatar || ''
      userInfo.avatarFile = null
      userInfoDialogVisible.value = true
    } else {
      ElMessage.error('获取用户信息失败，请重试')
    }
  } catch (error) {
    if (error?.isAuthExpired) return
    ElMessage.error(error.message || '获取用户信息失败，请重试')
  }
}

// 处理头像变更
const handleAvatarChange = (file) => {
  // 预览
  const reader = new FileReader()
  reader.onload = (e) => {
    userInfo.avatar = e.target.result
  }
  reader.readAsDataURL(file.raw)
  // 保存原始文件用于上传
  userInfo.avatarFile = file.raw
}

// 格式化手机号码，中间四位为*
const formatPhone = (phone) => {
  if (!phone || phone.length < 11) return phone
  return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')
}

// 格式化银行卡号，只显示前6位和后4位
const formatBankCard = (cardNo) => {
  if (!cardNo) return ''
  const str = String(cardNo).trim()
  if (str.length < 10) return str
  return str.replace(/^(\d{6})(\d+)(\d{4})$/, (match, p1, p2, p3) => {
    return `${p1}${'*'.repeat(p2.length)}${p3}`
  })
}

// 保存个人信息
const saveUserInfo = async () => {
  userInfoFormRef.value.validate(async (valid) => {
    if (valid) {
      saveLoading.value = true
      try {
        // 构造FormData
        const formData = new FormData()
        formData.append('name', userInfo.name)
        formData.append('role', userInfo.role)
        formData.append('idCard', userInfo.idCard)
        formData.append('phone', userInfo.phone)
        formData.append('nickname', userInfo.nickname)
        formData.append('qq', userInfo.qq)
        formData.append('bankCard', userInfo.bankCard)
        formData.append('bankName', userInfo.bankName)
        formData.append('address', userInfo.address)
        if (userInfo.avatarFile) {
          formData.append('avatar', userInfo.avatarFile)
        }
        // 发送请求
        const result = await http.put('/api/auth/update-profile', formData)
        if (result && result.user) {
          Object.assign(userInfo, result.user)
          ElMessage.success('个人信息保存成功')
          userInfoDialogVisible.value = false
        } else {
          throw new Error('保存失败：服务器返回数据无效')
        }
      } catch (error) {
        console.error('保存个人信息失败:', error)
        // 处理错误消息，确保能正确显示后端返回的错误信息
        let errorMessage = '保存个人信息失败，请重试'
        if (error.response) {
          const backendData = error.response.data || {}
          const backendErr = backendData.error
          // 身份证号唯一约束冲突：users_idcard_key
          if (typeof backendErr === 'string' && backendErr.includes('users_idcard_key')) {
            ElMessage.warning('该身份证号已注册，请勿重复注册')
            saveLoading.value = false
            return
          }
          // 优先使用 response.data.message
          if (backendData && backendData.message) {
            errorMessage = backendData.message
          } 
          // 如果没有 message，尝试使用 response.data.error
          else if (backendData && backendData.error) {
            errorMessage = backendData.error
          }
          // 如果是字符串格式的错误
          else if (typeof backendData === 'string') {
            errorMessage = backendData
          }
        } else if (error.message) {
          errorMessage = error.message
        }
        ElMessage.error(errorMessage)
      } finally {
        saveLoading.value = false
      }
    }
  })
}

// 获取当前用户权限
const getUserPermissionsFromStorage = () => {
  userPermissions.value = getUserPermissions()
  
  // 如果没有权限数据，可能需要从服务器获取
  if (userPermissions.value.length === 0) {
    fetchUserPermissions()
  }
}

// 从服务器获取用户权限
const fetchUserPermissions = async () => {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      router.push('/login')
      return
    }

    // 使用封装好的get函数并使用正确的API路径
    try {
      const userData = await get('/api/auth/profile', { _t: Date.now() })
      const perms = Array.isArray(userData?.permissions)
        ? userData.permissions
        : (Array.isArray(userData?.user?.permissions) ? userData.user.permissions : null)
      if (perms !== null) {
        userPermissions.value = perms
        localStorage.setItem('permissions', JSON.stringify(perms))
        if (!perms.length) {
          console.warn('后端返回空权限列表')
        }
      } else {
        console.warn('未能从 profile 解析 permissions，保留本地权限')
      }
    } catch (error) {
      if (error?.isAuthExpired) return
      console.error('API请求失败:', error)
      localStorage.removeItem('token')
      router.push('/login')
    }
  } catch (error) {
    console.error('获取用户权限失败:', error)
  }
}

// 退出登录
const handleLogout = () => {
  // 清除所有localStorage数据（但保留 loginRemember，因为用户可能勾选了"记住密码"）
  localStorage.removeItem('token')
  localStorage.removeItem('permissions')
  localStorage.removeItem('username')
  localStorage.removeItem('roles')
  localStorage.removeItem('nickname')
  localStorage.removeItem('avatar')
  localStorage.removeItem('userPermissions')
  localStorage.removeItem('userRoles')
  // 注意：不清除 loginRemember，因为用户可能勾选了"记住密码"
  
  // 清除store中的用户信息
  userStore.logout()
  
  // 检测是否为 Electron 环境
  const isElectron = typeof window !== 'undefined' && (
    window.electronAPI !== undefined ||
    window.navigator?.userAgent?.indexOf('Electron') !== -1 ||
    window.location?.protocol === 'file:'
  )
  
  if (isElectron) {
    // Electron 环境：使用 hash 路由跳转，清除所有URL参数
    // 先清除URL中的参数，然后跳转到登录页
    const currentUrl = new URL(window.location.href)
    // 清除 search 和 hash 中的参数
    currentUrl.search = ''
    currentUrl.hash = '#/login'
    const cleanUrl = currentUrl.toString()
    
    router.replace('/login').then(() => {
      // 使用完整的 clean URL，确保清除所有参数
      window.location.href = cleanUrl
    }).catch(() => {
      // 如果路由跳转失败，直接使用 clean URL
      window.location.href = cleanUrl
    })
  } else {
    // 浏览器环境：使用 history 模式，清除所有URL参数
    const currentUrl = new URL(window.location.href)
    currentUrl.search = ''
    currentUrl.hash = ''
    const cleanUrl = currentUrl.origin + '/login'
    
    router.replace('/login').then(() => {
      // 浏览器环境可以强制刷新，使用干净的URL
      window.location.href = cleanUrl
    }).catch(() => {
      window.location.href = cleanUrl
    })
  }
}

const goHomepage = () => {
  router.push('/')
}

const avatarUrl = computed(() => {
  if (!userInfo.avatar) return ''
  if (userInfo.avatar.startsWith('http')) return userInfo.avatar
  if (userInfo.avatar.startsWith('/')) return API_URL + userInfo.avatar
  return userInfo.avatar
})

const totalStorage = ref(0)
const limitStorage = ref(0)

const storagePercent = computed(() => {
  if (!limitStorage.value) return 0
  return Math.min(100, (totalStorage.value / limitStorage.value) * 100)
})

const storageText = computed(() => {
  const toGB = (v) => (v / 1024 / 1024 / 1024).toFixed(2)
  return `${toGB(totalStorage.value)}GB / ${toGB(limitStorage.value)}GB`
})

const storageColor = computed(() => {
  if (storagePercent.value >= 100) return '#F56C6C' // 红色
  if (storagePercent.value >= 80) return '#E6A23C' // 橙色
  return '#5B8CFF' // 蓝色
})

const dailyStorageCost = computed(() => {
  if (!totalStorage.value) return 0
  return Math.max(1, Math.ceil(totalStorage.value / 1024 / 1024 / 1024))
})

// 跳转到「存储空间管理」（头像下拉中的存储空间）
const goToTeamStorage = (e) => {
  if (e?.stopPropagation) e.stopPropagation()
  router.push('/team/storage').catch(() => {})
}

// 顶层定义，确保全局可用
async function refreshStorageProfile() {
  try {
    const data = await get('/api/auth/profile', { _t: Date.now() })
    if (data?.user) {
      totalStorage.value = data.user.total_storage || 0
      limitStorage.value = data.user.limit_storage || 1
    }
  } catch (e) {
    totalStorage.value = 0
    limitStorage.value = 1
  }
}


// 添加防抖优化，避免频繁触发
let resizeTimer = null
const debouncedCheckIsMobile = () => {
  if (resizeTimer) clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => {
    checkIsMobile()
    resizeTimer = null
  }, 50) // 减少防抖延迟时间以提高响应速度
}

// 添加节流函数
let throttleTimer = null
const throttledCheckIsMobile = () => {
  if (!throttleTimer) {
    throttleTimer = setTimeout(() => {
      checkIsMobile()
      throttleTimer = null
    }, 10) // 10ms节流
  }
}

// 加载用户头像信息
const loadUserAvatar = async () => {
  try {
    // 如果已经有 token，尝试加载用户信息
    if (localStorage.getItem('token')) {
      const userData = await userStore.fetchUserInfo()
      if (userData && userData.avatar) {
        userInfo.avatar = userData.avatar
      }
    }
  } catch (error) {
    console.error('加载用户头像失败:', error)
    // 静默失败，不影响页面加载
  }
}

onMounted(async () => {
  // QQ 登录回调：从 #/dashboard?token=...&openId=... 或 ?access_token=...&openid=... 换 JWT 并清掉 query
  const q = route.query
  if (q.token && q.openId) {
    try {
      const res = await http.post('/api/auth/qq-login', { token: q.token, openId: q.openId })
      const myToken = res?.token || res?.data?.token
      if (myToken) {
        userStore.setToken(myToken)
        localStorage.setItem('token', myToken)
        const profileRes = await getProfile()
        if (profileRes?.user) {
          userStore.setRoles(profileRes.user.role ? [profileRes.user.role] : [])
          if (Array.isArray(profileRes.user.permissions)) {
            userStore.setPermissions(profileRes.user.permissions)
          }
          userStore.userInfo = profileRes.user
        }
        router.replace({ path: '/dashboard' })
      }
    } catch (e) {
      console.error('QQ token 登录失败:', e)
      ElMessage.error(e?.response?.data?.message || e?.message || 'QQ登录失败')
    }
  } else if (q.access_token && q.openid) {
    try {
      const userInfoRes = await http.get('https://graph.qq.com/user/get_user_info', {
        params: { oauth_consumer_key: '102791102', access_token: q.access_token, openid: q.openid, format: 'json' }
      })
      const qqNickname = userInfoRes.data?.nickname
      const qqAvatar = userInfoRes.data?.figureurl_qq_2 || userInfoRes.data?.figureurl_qq_1
      const res = await http.post('/api/auth/qq-login', {
        openId: q.openid,
        accessToken: q.access_token,
        qqNickname,
        qqAvatar
      })
      const myToken = res?.token || res?.data?.token
      if (myToken) {
        userStore.setToken(myToken)
        localStorage.setItem('token', myToken)
        const profileRes = await getProfile()
        if (profileRes?.user) {
          userStore.setRoles(profileRes.user.role ? [profileRes.user.role] : [])
          if (Array.isArray(profileRes.user.permissions)) {
            userStore.setPermissions(profileRes.user.permissions)
          }
          userStore.userInfo = profileRes.user
        }
        router.replace({ path: '/dashboard' })
      }
    } catch (e) {
      console.error('QQ access_token 登录失败:', e)
      ElMessage.error(e?.response?.data?.message || e?.message || 'QQ登录失败')
    }
  }

  // 加载用户头像
  loadUserAvatar()
  // 检查是否为手机端
  checkIsMobile()
  // 同时使用防抖和节流来处理窗口大小变化
  window.addEventListener('resize', debouncedCheckIsMobile)
  window.addEventListener('resize', throttledCheckIsMobile)
  // 添加更积极的初始检查，确保正确设置移动端状态
  setTimeout(() => {
    checkIsMobile()
  }, 50)
  // 添加立即执行的检测以确保初始状态正确
  checkIsMobile()
  
  // token 校验，若无token则强制跳转登录页（用 router 保持 hash 路由一致，避免 Electron 白屏）
  if (!localStorage.getItem('token')) {
    router.replace('/login')
    return
  }
  // 获取用户权限
  getUserPermissionsFromStorage()

  companyAccessStore.refresh().catch(() => {})
  
  // 获取当前用户信息以设置正确的用户名显示
  userStore.fetchUserInfo().then((userData) => {
    if (userData || userStore.userInfo) {
      const data = userData || userStore.userInfo
      // 同步头像信息到 userInfo.avatar，以便头像能正常显示
      if (data && data.avatar) {
        userInfo.avatar = data.avatar
      }
      // 设置昵称，但不修改用户名
      if (data && data.nickname) {
        userStore.setNickname(data.nickname)
      }
      // 确保username是正确的
      if (data && data.username && (!userStore.username || userStore.username !== data.username)) {
        userStore.setUsername(userStore.userInfo.username)
      }
    }
  }).catch(error => {
    console.error('获取用户信息失败:', error)
  })

  await refreshStorageProfile() // 页面加载时主动刷新团队协作空间
  window.addEventListener('refresh-storage', refreshStorageProfile)

  if (window.electronAPI?.onScreenRecorderState) {
    window.electronAPI.onScreenRecorderState((payload = {}) => {
      const state = String(payload.recordingState || '')
      const active = payload.showMainMenu === false || state === 'recording' || state === 'paused' || state === 'stopping'
      if (payload.closeOverlay || payload.terminate || state === 'idle') {
        screenRecorderActive.value = false
        return
      }
      screenRecorderActive.value = active
    })
  }

  // 允许业务页面主动“呼出菜单”（主要用于手机/平板抽屉菜单）
  window.addEventListener('open-main-menu', () => {
    try {
      if (isMobile.value) mobileMenuVisible.value = true
      else if (isTablet.value) desktopMenuVisible.value = true
    } catch (e) {
      // ignore
    }
  })
})

onUnmounted(() => {
  // 移除防抖和节流事件监听器
  window.removeEventListener('resize', debouncedCheckIsMobile)
  window.removeEventListener('resize', throttledCheckIsMobile)
  window.removeEventListener('refresh-balance', handleRefreshBalance)
  stopArchivePolling()
  // 清除可能存在的定时器
  if (resizeTimer) clearTimeout(resizeTimer)
  if (throttleTimer) clearTimeout(throttleTimer)
})

// 检查是否为手机端和平板端
const checkIsMobile = () => {
  const width = window.innerWidth
  const newIsMobile = width <= 767
  const newIsTablet = width > 767 && width <= 1200
  // 总是更新isMobile和isTablet值以确保响应最新状态
  isMobile.value = newIsMobile
  isTablet.value = newIsTablet
  // 如果从平板切换到桌面，关闭折叠菜单
  if (!newIsTablet) {
    desktopMenuVisible.value = false
  }
  // 强制更新DOM
  nextTick(() => {
    // 触发组件更新
    window.dispatchEvent(new Event('resize'))
  })
}

// 严格的身份证号校验函数
function validateIdCard(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入身份证号'))
    return
  }
  // 18位身份证校验
  const idCardPattern = /^(\d{6})(19|20)?(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])(\d{3})([0-9Xx])$/
  if (!idCardPattern.test(value)) {
    callback(new Error('身份证号格式不正确'))
    return
  }
  // 校验校验码
  if (value.length === 18) {
    const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
    const sum = value
      .substring(0, 17)
      .split('')
      .reduce((acc, cur, idx) => acc + parseInt(cur, 10) * weights[idx], 0)
    const code = checkCodes[sum % 11]
    if (code !== value[17].toUpperCase()) {
      callback(new Error('身份证号校验码错误'))
      return
    }
  }
  callback()
}
</script>

<style scoped>
.btn-homepage {
  margin-right: 12px;
  border-color: rgba(0, 212, 255, 0.4);
  color: var(--color-primary-light);
}
.header-balance-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 16px;
}
.header-balance {
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-balance);
  white-space: nowrap;
}
.header-balance b {
  color: var(--color-balance-gold);
  font-size: 16px;
  font-weight: 700;
}
.coin-svg {
  margin-right: 2px;
  vertical-align: -3px;
  flex-shrink: 0;
}
.star-balance-inner {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.app-container {
  height: 100%; /* 填满父容器，避免 100vh 导致总高度超出视口出现右侧滚动条 */
  width: 100%;
}

.app-container.overlay-layout {
  width: 100vw;
  height: 100vh;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: transparent;
}

.layout-container {
  height: 100%;
}

.app-container.overlay-layout .layout-container {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: transparent;
}

/* 顶部导航栏样式 */
.top-header {
  background: linear-gradient(180deg, var(--color-bg-raised) 0%, var(--color-bg-fill2) 100%);
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  border-bottom: 1px solid rgba(0,184,212,0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  position: relative;
  z-index: 1000;
  overflow: hidden; /* 确保超出部分被隐藏 */
}

.top-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(0,212,255,0.3) 50%, 
    transparent 100%);
  pointer-events: none;
}

.header-left {
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
  min-width: 0; /* 允许flex子元素收缩 */
  overflow: hidden; /* 隐藏超出部分 */
}

.logo-container {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  background: var(--color-overlay-mid);
  border-right: 1px solid rgba(0,184,212,0.15);
  position: relative;
  z-index: 1;
  min-width: 180px;
}

.logo-text {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: var(--color-primary);
  letter-spacing: 3px;
  margin: 0;
  padding: 0;
  user-select: none;
  white-space: nowrap;
  transition: all 0.3s;
}

.logo-icon {
  font-size: 24px;
  margin-right: 10px;
  color: var(--color-primary-light);
  vertical-align: middle;
  filter: drop-shadow(0 0 6px rgba(0,212,255,0.6));
  transition: all 0.3s;
}

.logo-text:hover .logo-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 0 10px rgba(0,212,255,0.8));
}

/* 桌面端菜单折叠按钮 */
.desktop-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  color: var(--color-text-regular);
  font-size: 20px;
  cursor: pointer;
  padding: 8px 12px;
  margin-left: 16px;
  min-width: 44px;
  min-height: 44px;
  transition: all 0.3s;
  border-radius: 4px;
}

.desktop-menu-toggle:hover {
  background-color: var(--color-hover-bg);
  color: var(--color-primary-light);
}

.desktop-menu-toggle .el-icon {
  font-size: 20px;
  color: var(--color-text-regular);
}

.desktop-menu-toggle:hover .el-icon {
  color: var(--color-primary-light);
}

/* 顶部水平菜单样式 */
.top-menu {
  flex: 1;
  border-bottom: none !important;
  height: 64px;
  display: flex;
  align-items: center;
  padding-left: 0;
  transition: all 0.3s;
  min-width: 0; /* 允许flex子元素收缩 */
  overflow: hidden; /* 隐藏超出部分，Element Plus会自动将超出项放入"更多"菜单 */
  max-width: 100%; /* 确保不超过容器宽度 */
}

.top-menu.menu-collapsed {
  display: none;
}

.top-menu .el-menu-item,
.top-menu .el-sub-menu__title {
  height: 64px;
  line-height: 64px;
  padding: 0 20px !important;
  color: var(--color-text-regular);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 3px solid transparent;
  position: relative;
}

.top-menu .el-menu-item .el-icon,
.top-menu .el-sub-menu__title .el-icon {
  color: var(--color-text-secondary);
  font-size: 18px;
  margin-right: 8px;
  transition: all 0.3s;
}

.top-menu,
.mobile-menu,
.desktop-collapsed-menu {
  /* 显式设定 EP 菜单变量，避免 EP 从 CSS-var 的 background-color prop 计算出黑色 hover */
  --el-menu-bg-color: var(--color-bg-raised);
  --el-menu-hover-bg-color: var(--color-hover-bg);
  --el-menu-text-color: var(--color-text-primary);
  --el-menu-active-color: var(--color-primary-light);
  --el-menu-hover-text-color: var(--color-primary-light);
  --el-menu-sub-menu-bg-color: var(--color-bg-input);
}

.top-menu :deep(.el-menu-item:hover),
.top-menu :deep(.el-sub-menu__title:hover) {
  color: var(--color-primary-light);
  background: rgba(0,212,255,0.1);
  border-bottom-color: rgba(0,212,255,0.5);
}

.top-menu :deep(.el-menu-item:hover .el-icon),
.top-menu :deep(.el-sub-menu__title:hover .el-icon) {
  color: var(--color-primary-light);
  transform: scale(1.1);
}

.top-menu :deep(.el-menu-item.is-active) {
  color: var(--color-primary-light);
  background: var(--color-hover-bg);
  border-bottom-color: var(--color-primary-light);
  font-weight: 600;
}

.top-menu :deep(.el-menu-item.is-active .el-icon) {
  color: var(--color-primary-light);
}

.top-menu :deep(.el-sub-menu.is-opened > .el-sub-menu__title) {
  color: var(--color-primary-light);
  background: var(--color-hover-bg);
  border-bottom-color: var(--color-primary-light);
}

.top-menu :deep(.el-sub-menu.is-opened > .el-sub-menu__title .el-icon) {
  color: var(--color-primary-light);
}

/* 顶部菜单子菜单下拉样式 */
.top-menu :deep(.el-sub-menu .el-menu) {
  background: var(--color-bg-raised) !important;
  border: 1px solid rgba(0,184,212,0.2) !important;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  margin-top: 4px;
  padding: 4px 0;
  min-width: 160px;
}

/* Element Plus 水平菜单下拉框的 popper 样式 */
.top-menu :deep(.el-sub-menu__popper),
.top-menu :deep(.el-popper),
.top-menu :deep(.el-menu--horizontal .el-sub-menu__popper) {
  background-color: var(--color-bg-raised) !important;
  border: 1px solid rgba(0,184,212,0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;
}

.top-menu :deep(.el-sub-menu__popper .el-menu),
.top-menu :deep(.el-popper .el-menu),
.top-menu :deep(.el-menu--horizontal .el-sub-menu__popper .el-menu) {
  background-color: var(--color-bg-raised) !important;
  border: none !important;
}

.top-menu .el-sub-menu .el-menu-item {
  height: 44px;
  line-height: 44px;
  padding: 0 20px !important;
  color: var(--color-text-regular);
  font-size: 14px;
  border-radius: 4px;
  margin: 2px 8px;
  transition: all 0.3s;
}

.top-menu .el-sub-menu .el-menu-item:hover {
  background: var(--color-active-bg);
  color: var(--color-primary-light);
  transform: translateX(4px);
}

.top-menu .el-sub-menu .el-menu-item.is-active {
  background: linear-gradient(90deg, var(--color-active-bg) 0%, rgba(0,184,212,0.15) 100%);
  color: var(--color-primary-light);
  font-weight: 600;
}

/* Element Plus 水平菜单自动折叠的"更多"菜单样式 */
/* Element Plus 会自动将超出的菜单项放入"更多"菜单，使用三个点图标 */
.top-menu :deep(.el-menu--horizontal .el-menu__more),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more) {
  color: var(--color-text-regular);
  padding: 0 20px !important;
  height: 64px;
  line-height: 64px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.top-menu :deep(.el-menu--horizontal .el-menu__more:hover),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more:hover .el-sub-menu__title) {
  color: var(--color-primary-light);
  background: rgba(0,212,255,0.1);
  border-bottom-color: rgba(0,212,255,0.5);
}

.top-menu :deep(.el-menu--horizontal .el-menu__more .el-icon),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__title .el-icon) {
  color: var(--color-text-secondary);
  font-size: 18px;
  transition: all 0.3s;
}

.top-menu :deep(.el-menu--horizontal .el-menu__more:hover .el-icon),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more:hover .el-sub-menu__title .el-icon) {
  color: var(--color-primary-light);
  transform: scale(1.1);
}

.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more.is-opened > .el-sub-menu__title) {
  color: var(--color-primary-light);
  background: var(--color-hover-bg);
  border-bottom-color: var(--color-primary-light);
}

.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more.is-opened > .el-sub-menu__title .el-icon) {
  color: var(--color-primary-light);
}

/* "更多"菜单的下拉项样式 */
.top-menu :deep(.el-menu--horizontal .el-menu__more .el-sub-menu__popper .el-menu-item),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__popper .el-menu-item) {
  height: 44px;
  line-height: 44px;
  padding: 0 20px !important;
  color: var(--color-text-regular);
  font-size: 14px;
  border-radius: 4px;
  margin: 2px 8px;
  transition: all 0.3s;
}

.top-menu :deep(.el-menu--horizontal .el-menu__more .el-sub-menu__popper .el-menu-item:hover),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__popper .el-menu-item:hover) {
  background: var(--color-active-bg);
  color: var(--color-primary-light);
  transform: translateX(4px);
}

.top-menu :deep(.el-menu--horizontal .el-menu__more .el-sub-menu__popper .el-menu-item.is-active),
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__popper .el-menu-item.is-active) {
  background: linear-gradient(90deg, var(--color-active-bg) 0%, rgba(0,184,212,0.15) 100%);
  color: var(--color-primary-light);
  font-weight: 600;
}

/* "更多"菜单中的子菜单样式 */
.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__popper .el-sub-menu .el-sub-menu__title) {
  height: 44px;
  line-height: 44px;
  padding: 0 20px !important;
  color: var(--color-text-regular);
  font-size: 14px;
  border-radius: 4px;
  margin: 2px 8px;
}

.top-menu :deep(.el-menu--horizontal .el-sub-menu.is-more .el-sub-menu__popper .el-sub-menu .el-sub-menu__title:hover) {
  background: var(--color-active-bg);
  color: var(--color-primary-light);
}

.header-right {
  display: flex;
  align-items: center;
  padding-right: 24px;
  gap: 24px;
  height: 100%;
}

.storage-info {
  display: flex;
  align-items: center;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
}



.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* ===== 个人头像下拉菜单（el-dropdown 菜单渲染在 popper 浮动层，用 :deep 命中） ===== */
:deep(.user-menu) {
  min-width: 260px;
  padding: 8px;
}
:deep(.user-menu-storage) {
  padding: 12px 12px 10px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(0, 184, 212, 0.08), rgba(0, 184, 212, 0.03));
  border: 1px solid rgba(0, 184, 212, 0.14);
  cursor: pointer;
  transition: all 0.2s;
}
:deep(.user-menu-storage:hover) {
  background: linear-gradient(135deg, rgba(0, 184, 212, 0.16), rgba(0, 184, 212, 0.06));
  border-color: rgba(0, 184, 212, 0.3);
}
:deep(.user-menu-storage-head) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
:deep(.user-menu-storage-label) {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-primary-light, #00b8d4);
}
:deep(.user-menu-storage-meta) {
  font-size: 12px;
  color: var(--color-text-secondary, #8c9bab);
}
:deep(.user-menu-storage-bar) {
  height: 6px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
:deep(.user-menu-storage-fill) {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s;
}
:deep(.user-menu-storage-foot) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
}
:deep(.user-menu-storage-percent) {
  font-weight: 500;
}
:deep(.user-menu-storage-cost) {
  color: var(--color-warning, #e6a23c);
}
:deep(.user-menu-divider) {
  margin: 7px 0 5px;
}

.main-container {
  background: var(--color-bg-page);
  padding: 24px;
  min-height: calc(100% - 64px); /* 相对父容器高度，与 100vh 配合父级 100% 避免外层滚动条 */
  overflow-y: auto;
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 和 Edge */
}
.main-container.fullscreen {
  padding: 0;
  min-height: 100%;
}

.app-container.overlay-layout .main-container.fullscreen {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 0;
  overflow: hidden;
  background: transparent;
}

.main-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.avatar-uploader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.form-hint {
  font-size: 12px;
  color: var(--color-text-regular);
  margin-top: 5px;
}

.archive-alert {
  margin-bottom: 16px;
}

.archive-status-tabs {
  margin-bottom: 12px;
}

.archive-status-tabs :deep(.el-tabs__header) {
  margin-bottom: 0;
}

.archive-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.archive-search {
  width: 220px;
}

.archive-date-range {
  width: 360px;
  max-width: 100%;
}

.archive-work-select {
  width: 100%;
}

.archive-work-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.archive-work-main,
.archive-work-tags {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.archive-work-main {
  flex: 1;
}

.archive-work-main span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.archive-work-option small,
.archive-muted {
  color: #909399;
  font-size: 13px;
}

.archive-time-form {
  max-width: 560px;
}

.archive-options {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}

.archive-section {
  margin-top: 16px;
}

.archive-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
}

.archive-stats {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin: 12px 0;
  color: #606266;
  font-size: 13px;
}

.breadcrumb-nav .el-breadcrumb__item {
  color: var(--color-text-secondary);
}

.breadcrumb-nav .el-breadcrumb__item.is-last {
  color: var(--color-primary-light);
}

.storage-progress {
  display: inline-flex;
  align-items: center;
  margin-left: 0;
  font-size: 13px;
  color: var(--color-text-regular);
  white-space: nowrap;
}
.storage-label {
  margin-right: 8px;
  font-size: 15px;
  color: var(--color-text-primary);
}
.storage-text {
  margin-left: 8px;
  min-width: 90px;
  text-align: right;
  font-family: monospace;
}
.storage-text-compact {
  font-family: monospace;
  font-size: 13px;
  color: var(--color-text-primary);
  margin-right: 4px;
}
.storage-percent {
  font-size: 12px;
  font-weight: 500;
  margin-left: 2px;
}
.storage-daily-cost {
  font-size: 11px;
  color: #f0ad4e;
  white-space: nowrap;
  margin-left: 8px;
}

/* 手机端样式 */
.mobile-header {
  display: none;
  background: var(--color-bg-fill2);
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.mobile-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 15px;
}

.mobile-logo {
  display: flex;
  align-items: center;
}

.mobile-logo .logo-icon {
  font-size: 24px;
  margin-right: 8px;
  color: var(--color-primary-light);
}

.mobile-logo .logo-text {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.mobile-menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff !important;
  font-size: 28px !important;
  cursor: pointer;
  padding: 8px 12px;
  min-width: 44px;
  min-height: 44px;
  transition: all 0.3s;
  border-radius: 4px;
}

.mobile-menu-toggle:hover {
  background-color: var(--color-hover-bg);
  color: var(--color-primary-light) !important;
}

.mobile-menu-toggle .el-icon {
  font-size: 28px !important;
  color: #fff !important;
  display: block !important;
}

.mobile-menu-toggle .menu-toggle-text {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  white-space: nowrap;
}

.mobile-menu-toggle:hover .menu-toggle-text {
  color: var(--color-primary-light);
}

.mobile-menu-drawer {
  background: var(--color-bg-fill2) !important;
  width: 70% !important;
  max-width: 320px !important;
  height: 100vh !important;
  top: 0 !important;
  left: 0 !important;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  z-index: 2001 !important;
}

/* 遮罩层样式 */
.mobile-menu-drawer :deep(.el-drawer__mask) {
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 2000 !important;
}

/* 确保Element Plus抽屉的背景色和样式 */
.mobile-menu-drawer.el-drawer {
  background: var(--color-bg-fill2) !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.mobile-menu-drawer.el-drawer.ltr {
  background: var(--color-bg-fill2) !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.mobile-menu-drawer.el-drawer.ltr.open {
  background: var(--color-bg-fill2) !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

/* 确保抽屉内容铺满整个容器 */
.mobile-menu-content {
  height: 100%;
  width: 100%;
  background: var(--color-bg-fill2);
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 手机菜单项样式优化 */
.mobile-menu {
  border: none !important;
  border-radius: 0 !important;
  background: var(--color-bg-fill2) !important;
  width: 100%;
  height: calc(100% - 60px); /* 减去头部高度 */
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.mobile-menu-drawer :deep(.el-drawer__body) {
  padding: 0 !important;
  height: 100%;
  overflow: hidden;
}

.mobile-menu .el-menu-item,
.mobile-menu .el-sub-menu__title {
  background: var(--color-bg-fill2) !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 0 !important;
  margin: 0;
  padding-left: 20px !important;
}

.mobile-menu .el-menu-item.is-active {
  background: var(--color-bg-fill3) !important;
  color: var(--color-primary-light) !important;
}

/* 未选中的一级菜单项颜色 */
.mobile-menu > .el-menu-item:not(.is-active) {
  background: var(--color-bg-fill3) !important;
  color: #ffffff !important;
}

/* 未选中的子菜单项颜色 */
.mobile-menu .el-sub-menu .el-menu-item:not(.is-active) {
  background: var(--color-bg-fill3) !important;
  color: #ffffff !important;
}

/* 选中的一级菜单项颜色 */
.mobile-menu > .el-menu-item.is-active {
  background: var(--color-bg-fill3) !important;
  color: var(--color-primary-light) !important;
}

/* 选中的子菜单项颜色 */
.mobile-menu .el-sub-menu .el-menu-item.is-active {
  background: var(--color-bg-fill3) !important;
  color: var(--color-primary-light) !important;
}

/* 手机端菜单项悬停效果（:deep 作用于 el-menu 子组件内部，覆盖 EP 默认 hover） */
.mobile-menu :deep(.el-menu-item:hover),
.mobile-menu :deep(.el-sub-menu__title:hover) {
  background: var(--color-hover-bg) !important;
  color: var(--color-primary-light) !important;
}

/* 子菜单展开时的样式 */
.mobile-menu :deep(.el-sub-menu.is-opened > .el-sub-menu__title) {
  color: var(--color-primary-light) !important;
  background: var(--color-hover-bg) !important;
}

/* 确保子菜单项正确显示 */
.mobile-menu :deep(.el-sub-menu .el-menu) {
  background: var(--color-bg-input) !important;
}

.mobile-menu :deep(.el-sub-menu .el-menu .el-menu-item) {
  padding-left: 40px !important;
  background: var(--color-bg-input) !important;
}

.mobile-menu :deep(.el-sub-menu .el-menu .el-menu-item:hover) {
  background: var(--color-hover-bg) !important;
  color: var(--color-primary-light) !important;
}

.mobile-menu :deep(.el-sub-menu .el-menu .el-menu-item.is-active) {
  background: var(--color-active-bg) !important;
  color: var(--color-primary-light) !important;
}

/* 隐藏手机端不需要的菜单项 */
.mobile-menu .hide-on-mobile {
  display: none !important;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  height: 60px;
  border-bottom: 1px solid rgba(0,184,212,0.2);
  background: var(--color-bg-fill2);
}

.mobile-menu-logo {
  display: flex;
  align-items: center;
}

.mobile-menu-logo .logo-icon {
  font-size: 24px;
  margin-right: 8px;
  color: var(--color-primary-light);
}

.mobile-menu-logo .logo-text {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.close-icon {
  color: #ffffff; /* 改为白色，提高可见性 */
  font-size: 24px;
  cursor: pointer;
  padding: 10px;
}

/* 桌面端菜单折叠按钮 */
.desktop-menu-toggle {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: var(--color-text-regular);
  font-size: 20px;
  cursor: pointer;
  padding: 8px 12px;
  margin-left: 16px;
  min-width: 44px;
  min-height: 44px;
  transition: all 0.3s;
  border-radius: 4px;
}

.desktop-menu-toggle:hover {
  background-color: var(--color-hover-bg);
  color: var(--color-primary-light);
}

.desktop-menu-toggle .el-icon {
  font-size: 20px;
  color: var(--color-text-regular);
}

.desktop-menu-toggle:hover .el-icon {
  color: var(--color-primary-light);
}

.desktop-menu-toggle .menu-toggle-text {
  font-size: 14px;
  color: var(--color-text-regular);
  font-weight: 500;
  white-space: nowrap;
}

.desktop-menu-toggle:hover .menu-toggle-text {
  color: var(--color-primary-light);
}

.top-menu.menu-collapsed {
  display: none;
}

/* 桌面端折叠菜单抽屉样式 */
.desktop-menu-drawer {
  background: var(--color-bg-raised) !important;
  border-bottom: 1px solid rgba(0,184,212,0.2) !important;
}

.desktop-menu-drawer :deep(.el-drawer__body) {
  padding: 0 !important;
}

/* 抽屉遮罩层样式 */
.desktop-menu-drawer :deep(.el-drawer__mask) {
  background-color: rgba(0, 0, 0, 0.3) !important;
  z-index: 2000 !important;
}

.desktop-collapsed-menu {
  border: none !important;
  background: var(--color-bg-raised) !important;
}

.desktop-collapsed-menu .el-menu-item,
.desktop-collapsed-menu .el-sub-menu__title {
  color: var(--color-text-regular) !important;
  height: 48px;
  line-height: 48px;
}

.desktop-collapsed-menu :deep(.el-menu-item:hover),
.desktop-collapsed-menu :deep(.el-sub-menu__title:hover) {
  background: var(--color-hover-bg) !important;
  color: var(--color-primary-light) !important;
}

.desktop-collapsed-menu :deep(.el-menu-item.is-active) {
  background: var(--color-active-bg) !important;
  color: var(--color-primary-light) !important;
}

.desktop-collapsed-menu :deep(.el-sub-menu .el-menu) {
  background: var(--color-bg-input) !important;
}

.desktop-collapsed-menu :deep(.el-sub-menu .el-menu-item) {
  padding-left: 40px !important;
}

/* 中等屏幕（平板）样式 */
@media (min-width: 768px) and (max-width: 1200px) {
  .desktop-menu-toggle {
    display: flex;
  }
  
  .top-menu.menu-collapsed {
    display: none;
  }
  
  .header-right {
    flex-shrink: 0;
  }
  
  .storage-progress {
    display: none;
  }
  
  .breadcrumb-nav {
    display: none;
  }
}

@media (max-width: 767px) {
  .mobile-header {
    display: block;
  }
  
  /* 确保在移动端时桌面端layout完全隐藏 */
  .layout-container {
    display: none !important;
  }
  
  /* 确保在移动端时侧边栏不会占据空间 */
  .aside-container {
    display: none !important;
  }
  
  /* 手机端主内容区域 */
  .app-container {
    padding-top: 60px;
  }
  
  .main-container {
    padding: 20px 15px 15px 15px;
    min-height: calc(100vh - 60px);
  }
  
  .mobile-main-container {
    background: var(--color-bg-page);
    padding: 20px 15px;
    min-height: calc(100vh - 60px);
    overflow-y: auto;
  }
  .mobile-main-container.fullscreen {
    padding: 0;
    min-height: 100vh;
  }
  
  .header-container {
    padding: 0 15px;
  }
  
  .right-content .header-title {
    font-size: 14px;
    margin-right: 15px;
  }
  
  .storage-progress {
    font-size: 11px;
  }
  
  .storage-text-compact {
    font-size: 11px;
  }
  
  .storage-percent {
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .mobile-header-content {
    padding: 0 15px;
  }
  
  .mobile-logo .logo-text {
    font-size: 14px;
    letter-spacing: 1px;
  }
  
  .right-content .header-title {
    font-size: 13px;
    margin-right: 10px;
  }
  
  .storage-progress {
    font-size: 10px;
  }
  
  .storage-text-compact {
    font-size: 10px;
  }
  
  .storage-percent {
    font-size: 9px;
  }
  
  .user-info {
    font-size: 13px;
  }
  
  .el-avatar {
    width: 24px;
    height: 24px;
    line-height: 24px;
  }
}

/* 手机端优化个人信息弹窗，保证底部按钮可见 */
@media (max-width: 767px) {
  :deep(.el-dialog) {
    width: 96% !important;
    max-width: 480px;
    margin-top: 10vh !important;
  }

  :deep(.el-dialog__body) {
    max-height: 60vh;
    overflow-y: auto;
  }

  :deep(.el-dialog__footer) {
    position: sticky;
    bottom: 0;
    background: var(--color-bg-raised);
    border-top: 1px solid rgba(0,184,212,0.2);
    z-index: 1;
  }
}
</style>
